import { z } from "zod/v4";

export const availabilityWindowSchema = z.object({
	day_of_week: z.number().int().min(0).max(6),
	end_time: z.string(),
	start_time: z.string(),
});

export const setAvailabilitySchema = z.object({
	windows: z.array(availabilityWindowSchema),
});

export const availabilityResponseSchema = z.object({
	windows: z.array(availabilityWindowSchema),
});

export const userAvailabilitySchema = z.object({
	avatar_url: z.string().nullable().optional(),
	display_name: z.string(),
	user_id: z.string().uuid(),
	windows: z.array(availabilityWindowSchema),
});
